// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.screen_pSudT {
  height: 100%;
  display: grid;
  overflow: hidden;
}

.screen_pSudT.active_qm1zH {
  grid-template-columns: 1fr 450px;
}

.actionHeader_Pxjij {
  padding : 8px 16px;
  width : 100%;
  border-bottom:5px solid #F4F6FA;
}

.title_TB28e {
  width : 40%;
  flex-wrap: wrap!important;
}

.new_e3u2S {
  margin-left : 24px;
}

.search_OtI8x {
  width : 80%;
  max-width : 300px;
}

.cardSection_nSjwy {
  position : relative;
  overflow : scroll;
}
`, "",{"version":3,"sources":["webpack://./src/screens/enum/EnumGroupScreen.css"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,aAAa;EACb,gBAAgB;AAClB;;AAEA;EACE,gCAAgC;AAClC;;AAEA;EACE,kBAAkB;EAClB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;AACnB","sourcesContent":[".screen {\n  height: 100%;\n  display: grid;\n  overflow: hidden;\n}\n\n.screen.active {\n  grid-template-columns: 1fr 450px;\n}\n\n.actionHeader {\n  padding : 8px 16px;\n  width : 100%;\n  border-bottom:5px solid #F4F6FA;\n}\n\n.title {\n  width : 40%;\n  flex-wrap: wrap!important;\n}\n\n.new {\n  margin-left : 24px;\n}\n\n.search {\n  width : 80%;\n  max-width : 300px;\n}\n\n.cardSection {\n  position : relative;\n  overflow : scroll;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"screen": `screen_pSudT`,
	"active": `active_qm1zH`,
	"actionHeader": `actionHeader_Pxjij`,
	"title": `title_TB28e`,
	"new": `new_e3u2S`,
	"search": `search_OtI8x`,
	"cardSection": `cardSection_nSjwy`
};
export default ___CSS_LOADER_EXPORT___;
